import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

import ListV2 from '../content/list/ListV2';

function ConnectedHistoryRoute({ width, height, data }) {
  const tracks = data.slice(0, Config.RECENT_TRACKS_LIMIT);
  return (
    <Switch>
      <Route exact path="/history">
        <ListV2
          title={`Recently played`}
          titleContainerClassName={`title-border-bottom`}
          data={tracks}
          sortable={true}
          id={`history-tracks`}
          width={width}
          height={height - (Config.TAB_BAR_GUTTER * 2.5)}
          size={Config.LIST_ROW_HEIGHT}
          style={{marginTop: 0}}
          isLoadMore={false}
          type={`History`}
          enableKeys={true}
          enableShortcuts={true}
          automix={false}
          filtersStyle={{ position: `absolute`, top: -4, right: 0 }}
          panelStyle={{ margin: `4px 0px 8px 0px` }}
          orderBy={[`release`, `top`, `title`, `mix_name`, `remixers_s`, `label`, `genre_s`, `key_camelot`, `bpm`, `artists_s`]}
          filters={[`track_name`, /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `genre_s`, `bpm`, `key`]}
        />
      </Route>
    </Switch>
  );
}

ConnectedHistoryRoute.propTypes = {
  width: PropTypes.any,
  height: PropTypes.any,
  data:  PropTypes.array
}

const HistoryRoute = connect(
  state => ({
    width: state.dimension.width,
    height: state.dimension.height,
    data: state.historyTracks
  })
)(ConnectedHistoryRoute);

export default HistoryRoute;
